import { Document } from '../Shared/document';
import { SubSample } from './subsample';

export class Taxon {
    UUID: string = crypto.randomUUID();
    Code: string;
    SandreCode: number;
    CodeIBMR: string;
    CreatedOn: Date;

    Quantite: number;

    // IBMR
    // Unit: EUnit?
    // Presence: boolean

    Preleve: boolean = true;

    Quantite1: number;
    Quantite2: number;
    Quantite3: number;
    Quantite4: number;
    Quantite5: number;
    Quantite6: number;
    Quantite7: number;
    Quantite8: number;
    Quantite9: number;
    Quantite10: number;
    Quantite11: number;
    Quantite12: number;

    // IML
    Quantite13: number;
    Quantite14: number;
    Quantite15: number;
    //

    // IBMR UR1 (10) + UR2 (10)
    Quantite16: number;
    Quantite17: number;
    Quantite18: number;
    Quantite19: number;
    Quantite20: number;
    //

    QuantitePhaseA: number;
    QuantitePhaseB: number;
    QuantitePhaseC: number;

    Comment1: string;
    Comment2: string;
    Comment3: string;
    Comment4: string;
    Comment5: string;
    Comment6: string;
    Comment7: string;
    Comment8: string;
    Comment9: string;
    Comment10: string;
    Comment11: string;
    Comment12: string;

    // IML
    Comment13: string;
    Comment14: string;
    Comment15: string;

    // IBMR UR1 (10) + UR2 (10)
    Comment16: string;
    Comment17: string;
    Comment18: string;
    Comment19: string;
    Comment20: string;

    NomGenre: string;
    NomFamille: string;
    NomOrdre: string;
    NumeroPhase: number;

    // IBMR ONLY
    NumeroTransect: number;

    SubSample: SubSample;
    AnalyseCode: string;
    Position: number;
    Comment: string;
    Instruction: string;
    PictureList: Document[] = [];

    //** CYANO ONLY */
    Toxinogene: boolean
    Colonie: number = 0
    CanUndo: boolean = false
    IsPhyto: boolean = false;
    //** !CYANO ONLY */

    static mapFromJSON(json): any {
        const t = new Taxon();

        t.Code = json.code;
        t.Preleve = json.preleve;
        t.CodeIBMR = json.codeIBMR;
        t.CreatedOn = json.createdOn;
        t.SandreCode = json.sandreCode;
        t.Quantite = json.quantite;
        t.NomFamille = json.nomFamille;
        t.NomGenre = json.nomGenre;
        t.NomOrdre = json.nomOrdre;
        t.NumeroPhase = json.numeroPhase;
        t.NumeroTransect = json.numeroTransect;
        t.Position = json.position;
        t.Comment = json.comment;
        t.Instruction = json.instruction;
        t.Toxinogene = json.toxinogene;
        t.Colonie = json.colonie;
        t.CanUndo = json.canUndo;
        t.IsPhyto = json.isPhyto;

        if (json.pictureList) {
            t.PictureList = json.pictureList.map(jsonItem => Document.mapFromJSON(jsonItem));
        }

        return t;
    }
}
